"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDTO = void 0;
class FormDTO {
    id;
    name;
    tags;
    createdAt;
    status;
    content;
    template;
    user;
    reviewer;
    statusDate;
}
exports.FormDTO = FormDTO;
